export default {"src":"/_next/static/media/mw.0faa1d19.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};